import { Membership } from '@moovly/clients/lib/resources/group/group.interfaces';
import { Select } from '@moovly/ui';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { updateMembership } from '../../../store/members.store';
import { clients } from '@moovly/clients';

interface UserRoleSelectContainerProps {
  membership: Membership;
}

const UserRoleSelectContainer: React.FC<UserRoleSelectContainerProps> = ({ membership }) => {
  const dispatch = useDispatch<any>();
  const [roles, setRoles] = React.useState<{ value: string; label: string; }[]>();

  const handleRoleChange = React.useCallback(
    ({ value }: { value: string }) => {
      dispatch(updateMembership({ groupId: membership.group_id, memberId: membership.id, role: value }));
    },
    [dispatch, membership]
  );

  React.useEffect(() => {
    async function getRolesForGroup() {
      let roles = await clients.Group.getGroupRoles(membership.group_id);
      setRoles(roles.map((role) => ({value:role.name, label: role.name})));
    }

    getRolesForGroup();
  }, [membership]);

  return (roles && (
    <div className="child-no-margin" style={{textTransform: 'capitalize'}}>
      <Select
        name="SelectUserRole"
        id="RoleSelect"
        onChange={handleRoleChange}
        options={roles}
        value={roles.find((r) => r.label === membership.role)}

      />
    </div>
  ));
};

export default UserRoleSelectContainer;
